import styled from "styled-components";

const AdminFormToolbar = styled.form`
  display: flex;
  align-items: ${({ $inline }) => ($inline ? "center" : "stretch")};
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-bottom: ${({ $inline }) => ($inline ? "0" : "1rem")};
`;

export default AdminFormToolbar;
